import React, { useState } from "react";
import { useDrop } from "react-dnd";

import { ItemTypes } from "../../utils/items";

import "./Compare.css";

const ApartmentViewerBox = (props) => {
    const [apartmentViewed, setApartment] = useState(null);
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [type, setType] = useState("");
    const [quadrature, setQuadrature] = useState("");
    const [pageNumber, setPageNumber] = useState(1);

    const [{ isOver }, drop] = useDrop({
        accept: ItemTypes.APARTMENT,
        drop: (item, monitor) => {
            setApartment(item.id);
            setImage(item.twoDimensionalPlan);
            setType(item.apartmentType);
            setQuadrature(item.quadrature);
            setName(item.name);
            props.setApartmentViewed(item.id, props.number);
        },
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });


    return (
        <div ref={drop} className="apartment-viewer-box">
            {props.isSet ? (
                <div className="apartment_type">
                    <span className="apr-name">Appartement</span>
                    <span className="apr-num"> {props.apartmentInfo.name}</span>
                    <span className="apr-type">{props.apartmentInfo.type}</span>
                    <span className="apr-area">
                        {props.apartmentInfo.quadrature} m<sup>2</sup>
                    </span>
                </div>
            ) : null}

            {
                <div
                    style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        overflow: "auto",
                    }}
                >
                    <button
                        className="remove_favourite-button"
                        onClick={() => {
                            props.removeViewedApartment(props.number);
                            setApartment(null);
                            setImage(null);
                            setType(null);
                        }}
                    >
                        X
                    </button>
                    <canvas
                        id={`viewed-apt${props.number}`}
                        style={props.style}
                    ></canvas>
                </div>
            }
        </div>
    );
};

export default ApartmentViewerBox;
